import isEmpty from 'lodash/isEmpty';
import styled from '@emotion/styled';
import { NextPage } from 'next';
import { memo } from 'react';
// import { IArticle } from 'src/interface/section';
import dynamic from 'next/dynamic';
import { SHOW_COMMEMORATE } from 'src/constants';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
const WidgetTranslate = dynamic(import('./widget-translate'));
const WidgetShareSticky = dynamic(import('../widget-share-sticky'));
const WidgetSpeech = dynamic(import('./widget-speech'));

type Props = {
  article?: any;
  title?: string;
  tag?: string;
  className?: any;
  handleTranslate?: any;
  router?: any;
  selectLang?: string;
  isLoading?: boolean;
};
const WidgetStickyContent: NextPage<Props> = ({ selectLang, article, className = '', handleTranslate, router = null }) => {
  if (isEmpty(article)) return null;

  return (
    <>
      <WidgetWrapper id='widget-contents' className={`${className}`} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
        <div id={'widget-group'} className={'position-sticky-left-content back-drops'}>
          <div className='share-wrapper'>
            <WidgetTranslate
              article={article}
              selectLang={selectLang}
              handleTranslate={handleTranslate}
              // ! DATALAYER
              eventDataLayer={{
                type: DATALAYER_TYPE.TRACK_POSITION,
                router: router?.pathname,
                section: 'แปลภาษา',
                position: 'ใต้รูปภาพปก:content',
                data: {
                  heading: 'แปลภาษา',
                  block: '1',
                  router: router?.pathname
                }
              }}
            />
            <WidgetSpeech
              selectLang={selectLang}
              article={article}
              // ! DATALAYER
              eventDataLayer={{
                type: DATALAYER_TYPE.TRACK_POSITION,
                router: router?.pathname,
                section: 'ฟังเสียงอ่าน',
                position: 'ใต้รูปภาพปก:content',
                data: {
                  heading: 'ฟังเสียงอ่าน',
                  block: '1'
                }
              }}
            />
            <WidgetShareSticky
              article={article}
              link={article?.link}
              // ! DATALAYER
              eventDataLayer={{
                type: DATALAYER_TYPE.TRACK_POSITION,
                router: router?.pathname,
                section: 'แชร์ข่าว',
                position: 'ใต้รูป:content',
                data: {
                  heading: 'แชร์ข่าว'
                }
              }}
            />
          </div>
        </div>
      </WidgetWrapper>
    </>
  );
};
const WidgetWrapper = styled.div`
  padding-bottom: 10px;
  @media (max-width: 768px) {
    padding-bottom: 0px;
  }

  &.block-sticky {
    position: sticky;
    top: 165px;
    display: block;
    background-color: #fff;
    text-align: center;
    z-index: 1;
    @media (max-width: 1280px) {
      top: 127px;
    }
    @media (max-width: 1024px) {
      top: 170px;
    }
    @media (max-width: 769px) {
      top: 185px;
    }
    @media (max-width: 767px) {
      display: block;
      text-align: center;
      width: 100%;
      margin: auto;
      right: 0;
      left: 0;
      z-index: 5;
    }
    @media (max-width: 480px) {
      top: 177px;
      height: 0;
    }
  }
  .widget-share {
    margin: 0;
  }
  .share-wrapper {
    position: relative;
    padding-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    @media (max-width: 992px) {
      width: 100%;
      gap: 8px;
      padding: 0;
    }
    @media (max-width: 768px) {
      gap: 3px;
    }
  }

  .position-sticky-left-content {
    width: 100%;
    margin: auto;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px 10px 0px;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 8px 8px -5px rgba(0, 0, 0, 0.4);
    top: 0;
    left: 0;
    &.back-drops {
      margin-bottom: 10px;
      background-color: white;
    }
    @media (max-width: 768px) {
      padding: 10px 20px;
    }
    @media (max-width: 767px) {
      border-radius: 0 0 15px 15px;
      width: 100vw !important;
    }
    @media (max-width: 767px) {
      position: sticky;
      padding: 8px 5px;
      top: 79px;
      left: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 5px;
      width: 100% !important;
      min-height: 40px;
      z-index: 100;
    }
  }
`;

export default memo(WidgetStickyContent);
